import React, {Component, useState } from "react";

// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import LoadingOverlay from 'react-loading-overlay';
import _ from '../../utils/languages/languages';
import ScheduleView from "../../widgets/ScheduleView";
import InsertMeetingWidget from "../../widgets/InsertMeetingWidget";
import EditMeetingWidget from "../../widgets/EditMeetingWidget";
import EditBreakWidget from "../../widgets/EditBreakWidget";
import GetInvestorService from '../../services/getInvestorsAnalysts';
import GetCompanyService from '../../services/getCompany';
import GetEventService from '../../services/getEvent';
import EmptyPage from '../../widgets/EmptyPage';
import GetMeetingsService from '../../services/getMeetings';
import GetBreaksService from '../../services/getBreaks';
import GetCompanies from '../../services/getCompanies';
import ManageScheduleNotes from '../../services/manageScheduleNotes';
import moment from 'moment';
import Utils from '../../utils/utils';
import {
  ArrowBack as ArrowBack,
  ArrowForward as ArrowForward,
} from "@material-ui/icons";


export default class Master extends React.Component {

  constructor(props){
    super (props)
  
    this.pageDiv = {
      border: '1px solid #cccccc',
      padding: 10
    };
  
    this.linkClicked = false;

    this.section = this.props.section
    if (this.section == undefined){
      const pathname = props.location.pathname;
      this.section = pathname.substring(8, pathname.length);
    }

    this.pageTitle = props.pageTitle;
    this.pageName = props.pageName;
    this.titlePage = '';

    if (this.pageName == undefined){
      this.pageName = this.section;
    }

    this.userslist = [];
    this.subjectName = '';
    this.eventDays = [];
    this.meetings = [];

    this.state = {
      testo: '',
      menuBackground: '#ffffff',
      menuItemColor: '#000000',
      fontSize: 50,
      fontBold: false,
      logoPicture: '',
      logoMargin: 0,
      titleColor: '#000000',
      titleSize: 18,
      isLoading: false,
      addElementVisible: false,
    }

    this.grid = 2;

    this.pageTitle = "Master";

    this.state = {
      newEventParam: {
        visible: false,
        name: undefined,
        subjectId: undefined
      },
      editEventParam: {
        visible: false,
        meeting: undefined,
        name: undefined,
        subjectId: undefined
      },
      editBreakParam: {
        visible: false,
        break: undefined,
        name: undefined,
        subjectId: undefined
      }   
    };

  }

  async reload(){
    const cookies = new Cookies();
    const username = cookies.get('username', { path: '/' });
    const token = cookies.get('token', { path: '/' });
    const scheduleType = 'company';
    const eventId = cookies.get('currentEventId', { path: '/' });

    this.scheduleType = scheduleType;

//    this.investor = await GetInvestorService(username, token, eventId, scheduleSubject);
//    this.company = await GetCompanyService(username, token, eventId, scheduleSubject);
    this.event = await GetEventService(username, token, eventId);
    this.meetings = await GetMeetingsService(username, token, eventId);
    this.breaks = await GetBreaksService(username, token, eventId);
    this.investors = await GetInvestorService(username, token, eventId, '');
    this.companies = await GetCompanies(username, token, eventId);

    if (this.event == undefined) return;

    var startDate = this.event.startDate;
    var endDate = this.event.endDate;

    startDate = moment(startDate, "DD/MM/yyyy");
    endDate = moment(endDate, "DD/MM/yyyy");

    this.eventDays = [];
    var tempDate = startDate;
    while (tempDate <= endDate){
      this.eventDays.push(moment(tempDate));
      tempDate = tempDate.add(1, 'd');
    }
    
    this.setState({      
      editEventParam: {
        visible: false,
        meeting: undefined,
    },
  });
  }

  async componentDidMount(){
    this.datePageIndex = 0;

    this.reload();
  }

  hideEditWindow () {
    this.linkClicked = true;
    this.setState({editEventParam: {visible: false }});
    this.setState({editBreakParam: {visible: false }});
  }

  render () {

    const cookies = new Cookies();
    const currentEventName = cookies.get('currentEventName', { path: '/' });

    function createData(username, name, surname) {
      return { username, name, surname };
    }

    var rows = [];
    this.userslist.length > 0 && this.userslist.map((v, k) => {
      rows.push(createData(v.username, v.name, v.surname));
    });

    this.linkClicked = false;

    if (this.datePageIndex >= this.eventDays.length)
      this.datePageIndex = this.eventDays.length - 1;
    let date = moment(this.eventDays[this.datePageIndex]).format('DD/MM/yyyy');


    if (currentEventName == '' || currentEventName == undefined){
      return <EmptyPage />;
    }

    return (
      <>
      <LoadingOverlay
      active={this.state.isLoading}
      styles={{
        content: (base) => ({
          position: 'relative',
          width: '100%',
          top: '200px'
        })
      }}
      spinner
      text={_.tr('Loading your content...')}
      >
        <PageTitle title={this.pageTitle} />
        <div style={{textAlign: 'center'}}>
          <div style={{display: 'inline-flex', textAlign: 'center'}}>
            {
              this.datePageIndex > 0 ? <ArrowBack style={{}} onClick={() => {
                this.datePageIndex--;
                this.reload();
              }} /> : <div />
          }
            <div key={Math.random()} style={{}}>{date}</div>
            {
              this.datePageIndex < this.eventDays.length - 1 ? <ArrowForward onClick={() => {
                this.datePageIndex++;
                this.reload();
              }} /> : <div />
          }


        </div></div><br /><br />
        { 

        this.companies && this.companies.map((company) => {

          var scheduleSubject = company.id;
          var scheduleName = company.name;

            return (
            <div>
              <b>{company.name}</b>
              <ScheduleView 
              key={Math.random()}
              meetings={this.meetings} 
              breaks={this.breaks} 
              date={date} 
              parent={this}
              type={this.scheduleType}
              masterFlag={true}
              subject={scheduleSubject} 
              onMouseClick={(date, time) => {

              if (this.linkClicked == true) return;
              
              for (var i = 0; i < this.breaks.length; i++){

                let b = this.breaks[i];
                if (b.type != this.scheduleType) continue;
                if (b.subject != this.scheduleSubject) continue;
                if (b.date != date) continue;

                var breakStart = moment(b.date + " " + b.hour+":"+b.minutes, "DD/MM/yyyy HH:mm");
                var breakEnd = moment(breakStart).add(parseInt(b.slots) * 5, 'minutes');

                let currentClickTime = moment(date + " " + time, "DD/MM/yyyy HH:mm");
                if (currentClickTime >= breakStart && breakEnd > currentClickTime) {

                  this.setState({
                    editBreakParam: {
                      visible: true,
                      break: b,
                      name: scheduleName,
                      subjectId: scheduleSubject
                    }
                  });

                  return;
                }
              }

              for (var i = 0; i < this.meetings.length; i++){

                let m = this.meetings[i];
                if (this.scheduleType == 'investor' && Utils.checkInvestor(m.investors, scheduleSubject) == false) continue;
                if (this.scheduleType == 'company' && m.company_id != scheduleSubject) continue;

                var meetingStart = moment(m.date + " " + m.hour+":"+m.minutes, "DD/MM/yyyy HH:mm");
                var meetingEnd = moment(meetingStart).add(parseInt(m.slots) * 5, 'minutes');

                let currentClickTime = moment(date + " " + time, "DD/MM/yyyy HH:mm");
                if (currentClickTime >= meetingStart && meetingEnd > currentClickTime) {

                  this.setState({
                    editEventParam: {
                      visible: true,
                      meeting: m,
                      name: scheduleName,
                      subjectId: scheduleSubject
                    }
                  });

                  return;
                }
              }

              this.setState({
                newEventParam: {
                  visible: true,
                  date: date,
                  time: time,
                  name: scheduleName,
                  subjectId: scheduleSubject
                }
              });

            }}
          />
          </div>);
          })
          
  }
  {
        this.state.editBreakParam.break && <EditBreakWidget 
          key={Math.random()}
          visible={this.state.editBreakParam.visible ? true : false}
          break={this.state.editBreakParam.break} 
          meetings={this.meetings} 
          breaks={this.breaks} 
          scheduleType={this.scheduleType}
          subjectName={this.state.editBreakParam.name}
          subjectId={this.state.editBreakParam.subjectId}
          investors={this.investors}
          companies={this.companies}
          onDone={() => {
            this.reload();
            this.setState({editBreakParam: {visible: false }});
          } }
        />
        }
        
        { this.state.editEventParam.meeting && <EditMeetingWidget 
          key={Math.random()}
          visible={this.state.editEventParam.visible ? true : false}
          meeting={this.state.editEventParam.meeting} 
          meetings={this.meetings} 
          breaks={this.breaks} 
          scheduleType={this.scheduleType}
          subjectName={this.state.editEventParam.name}
          subjectId={this.state.editEventParam.subjectId}
          investors={this.investors}
          companies={this.companies}
          onDone={() => {
            this.reload();
            this.setState({editEventParam: {visible: false }});
          } }
        />
        }

        <InsertMeetingWidget 
          key={Math.random()}
          visible={this.state.newEventParam.visible ? true : false}
          date={this.state.newEventParam.date}
          time={this.state.newEventParam.time}
          meetings={this.meetings} 
          breaks={this.breaks} 
          scheduleType={this.scheduleType}
          subjectName={this.state.newEventParam.name}
          subjectId={this.state.newEventParam.subjectId}
          investors={this.investors}
          companies={this.companies}
          onDone={() => {
            this.reload();
            this.setState({newEventParam: {visible: false }});
          } }
        />
        </LoadingOverlay>
      </>
    );
  }

}

